const selector = "[data-resend-cooldown]";

function updateCooldown(container) {
  const button = container.querySelector("[data-resend-button]");
  const message = container.querySelector("[data-resend-countdown]");
  if (!button || !message) return;

  const deadline = Date.parse(container.dataset.resendAvailableAt) || 0;
  const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
  if (seconds > 0) {
    button.disabled = true;
    button.dataset.resendCoolingDown = "true";
  } else if (button.dataset.resendCoolingDown === "true") {
    button.disabled = button.dataset.busy === "true" || button.closest("form")?.hasAttribute("aria-busy");
    delete button.dataset.resendCoolingDown;
  }
  message.hidden = seconds === 0;
  const time = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
  message.textContent = message.dataset.resendCountdown.replace("%{time}", time);
}

export function startConfirmationCooldown(container, seconds) {
  if (!container) return;
  container.dataset.resendAvailableAt = new Date(Date.now() + (Number(seconds) || 0) * 1000).toISOString();
  updateCooldown(container);
}

function updateCooldowns() {
  document.querySelectorAll(selector).forEach(updateCooldown);
}

document.addEventListener("turbo:load", updateCooldowns);
document.addEventListener("pageshow", updateCooldowns);
document.addEventListener("DOMContentLoaded", updateCooldowns);
// Absolute deadlines keep background tabs and Turbo's cached pages accurate.
window.setInterval(updateCooldowns, 1000);
updateCooldowns();
